  if (!customElements.get('facet-form')) {
    customElements.define(
      'facet-form',
      class FacetForm extends HTMLFormElement {
        constructor() {
          super();

          this.dirty = false;
          this.cachedMap = new Map();
          this.isMobile = theme.config.mqlSmall || theme.config.isTouch;
          this.motionReduced = theme.config.motionReduced || this.hasAttribute('motion-reduced');

          this.addEventListener('change', this.onFormChange);
          this.addEventListener('submit', this.onFormSubmit);
        }

        getAnimationParams() {
          return {
            distance: this.isMobile ? 30 : 50,
            duration: this.motionReduced ? 0 : (this.isMobile ? 0.3 : 0.5),
            staggerDelay: this.motionReduced ? 0 : (this.isMobile ? 0.05 : 0.1)
          };
        }

        getVisibleItems(items) {
          const viewportHeight = window.innerHeight + window.scrollY;
          const visible = [];
          const invisible = [];
          
          items.forEach(item => {
            const rect = item.getBoundingClientRect();
            const isVisible = rect.top < viewportHeight && rect.bottom > 0;
            
            if (isVisible) {
              visible.push(item);
            } else {
              invisible.push(item);
            }
          });
          
          return { visible, invisible };
        }

        onFormChange(event) {
          const target = event && event.target;
          if (target && target.matches && target.matches('input.facet-menu-collection-filter-cb')) {
            if (typeof window.facetMenuCollectionOnChange === 'function') {
              window.facetMenuCollectionOnChange(event);
            }
            return;
          }
          this.dirty = true;
          this.dispatchEvent(new Event('submit', { cancelable: true }));
        }

        onFormSubmit(event) {
          event.preventDefault();
          if (!this.dirty) return;

          const url = this.buildUrl().toString();
          this.renderSection(url, event);
        }

        buildUrl() {
          const searchParams = new URLSearchParams(new FormData(this));
          const url = new URL(this.action);

          url.search = '';
          searchParams.forEach((value, key) => url.searchParams.append(key, value));

          ['page', 'filter.v.price.gte', 'filter.v.price.lte'].forEach((item) => {
            if (url.searchParams.get(item) === '') {
              url.searchParams.delete(item);
            }
          });

          url.searchParams.set('section_id', theme.utils.sectionId(this));
          return url;
        }

        updateURLHash(url) {
          const clonedUrl = new URL(url);
          clonedUrl.searchParams.delete('section_id');
          history.replaceState({}, '', clonedUrl.toString());
        }

        beforeRenderSection() {
          const container = document.getElementById('ProductGridContainer');
          if (!container) return;
          const items = container.querySelectorAll('.product-card, .xs-card');

          const { distance, duration, staggerDelay } = this.getAnimationParams();
          const { visible: visibleItems, invisible: inVisibleItems } = this.getVisibleItems(items);

          Motion.timeline([
            [visibleItems, { y: distance, opacity: 0, visibility: 'hidden' }, { duration: duration, delay: Motion.stagger(staggerDelay) }],
            [inVisibleItems, { y: distance, opacity: 0, visibility: 'hidden' }, { duration: duration }],
            [container, { y: distance, opacity: 0 }, { duration: duration, easing: 'linear' }]
          ]);
          items.forEach(item => item.style.removeProperty('transform'));

          let headerHeight = 0;
          if (!theme.config.mqlSmall && document.querySelector('header.header')) {
            headerHeight = Math.round(document.querySelector('header.header').clientHeight);
          }
          setTimeout(() => {
            const target = document.querySelector('.collection') || document.querySelector('.xiaomi-collection');
            if (!target) return;
            window.scrollTo({
              top: target.getBoundingClientRect().top + window.scrollY - (theme.config.isTouch || theme.config.mqlSmall ? 95 : 20) - headerHeight,
              behavior: theme.config.motionReduced ? 'auto' : 'smooth'
            });

            var drawer = document.getElementById('FacetDrawer');
            if (drawer) drawer.classList.add('loading');
            var filterSearchDrawer = document.getElementById('FilterSearchDrawer');
            if (filterSearchDrawer) filterSearchDrawer.classList.add('loading');
          }, 100);
        }

        afterRenderSection() {
          const container = document.getElementById('ProductGridContainer');
          if (!container) return;
          const items = container.querySelectorAll('.product-card, .xs-card');

          const { distance, duration, staggerDelay } = this.getAnimationParams();
          const { visible: visibleItems, invisible: inVisibleItems } = this.getVisibleItems(items);

          Motion.timeline([
            [container, { y: [distance, 0], opacity: [0, 1] }, { duration: duration, easing: 'linear' }],
            [visibleItems, { y: [distance, 0], opacity: [0, 1], visibility: ['hidden', 'visible'] }, { duration: duration, delay: Motion.stagger(staggerDelay) }],
            [inVisibleItems, { y: [distance, 0], opacity: [0, 1], visibility: ['hidden', 'visible'] }, { duration: duration }]
          ]);
          items.forEach(item => item.style.removeProperty('transform'));

          var drawer = document.getElementById('FacetDrawer');
          if (drawer) drawer.classList.remove('loading');
          var filterSearchDrawer = document.getElementById('FilterSearchDrawer');
          if (filterSearchDrawer) filterSearchDrawer.classList.remove('loading');

          document.dispatchEvent(new CustomEvent('collection:reloaded'));
        }

        renderSection(url, event) {
          this.cachedMap.has(url)
            ? this.renderSectionFromCache(url, event)
            : this.renderSectionFromFetch(url, event);

          if (this.hasAttribute('data-history')) this.updateURLHash(url);

          this.dirty = false;
        }

        renderSectionFromFetch(url, event) {
          this.abortController?.abort();
          this.abortController = new AbortController();
          
          this.beforeRenderSection();
          const start = performance.now();

          fetch(url, { signal: this.abortController.signal })
            .then((response) => response.text())
            .then((responseText) => {
              const execution = (performance.now() - start);

              setTimeout(() => {
                this.renderFilters(responseText, event);
                this.renderFiltersActive(responseText);
                this.renderProductGridContainer(responseText);
                this.renderProductCount(responseText);
                this.renderSortBy(responseText);

                theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.facetUpdate, { responseText: responseText });
                this.cachedMap.set(url, responseText);

                this.afterRenderSection();
              }, execution > 500 ? 0 : 500);
            })
            .catch((error) => {
              if (error.name === 'AbortError') {
                console.log('Fetch aborted by user');
              }
              else {
                console.error(error);
              }
            });
        }

        renderSectionFromCache(url, event) {
          this.beforeRenderSection();

          setTimeout(() => {
            const responseText = this.cachedMap.get(url);
            this.renderFilters(responseText, event);
            this.renderFiltersActive(responseText);
            this.renderProductGridContainer(responseText);
            this.renderProductCount(responseText);
            this.renderSortBy(responseText);

            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.facetUpdate, { responseText: responseText });

            this.afterRenderSection();
          }, 500);
        }

        renderFilters(responseText, event) {
          const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');

          const xiaomiForm = document.getElementById('XiaomiFacetForm');
          const parsedXiaomiForm = parsedHTML.getElementById('XiaomiFacetForm');
          if (xiaomiForm && parsedXiaomiForm) {
            xiaomiForm.innerHTML = parsedXiaomiForm.innerHTML;
            return;
          }

          const facetElements = parsedHTML.querySelectorAll(
            '#FacetFiltersContainer [data-filter], #MobileFacetFiltersContainer [data-filter]'
          );

          const matchesIndex = (element) => {
            const jsFilter = event ? event.target.closest('[data-filter]') : undefined;
            return jsFilter ? element.getAttribute('data-index') === jsFilter.getAttribute('data-index') : false;
          };
          const facetsToRender = Array.from(facetElements).filter((element) => !matchesIndex(element));

          facetsToRender.forEach((element) => {
            const filter = document.querySelector(`[data-filter][data-index="${element.getAttribute('data-index')}"]`);
            if (filter !== null) {
              if (filter.tagName === 'DETAILS') {
                filter.querySelector('summary + *').innerHTML = element.querySelector('summary + *').innerHTML;
              }
              else {
                filter.innerHTML = element.innerHTML;
              }
            }
          });

          this.renderFilterSearchDrawer(responseText);
        }

        renderFilterSearchDrawer(responseText) {
          const slot = document.getElementById('FilterSearchDrawerContentSlot');
          const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
          const responseSource = parsedHTML.getElementById('FilterSearchDrawerContentSource');
          if (slot && responseSource && responseSource.innerHTML) {
            slot.innerHTML = responseSource.innerHTML;
          }
          if (typeof window.facetMenuCategoryBindLinks === 'function') {
            window.facetMenuCategoryBindLinks();
          }
          if (typeof window.facetCategorySubfilterRefresh === 'function') {
            window.facetCategorySubfilterRefresh();
          }
        }

        renderFiltersActive(responseText) {
          const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');

          const xiaomiToolbar = document.querySelector('.xiaomi-collection__toolbar-bar');
          const parsedXiaomiToolbar = parsedHTML.querySelector('.xiaomi-collection__toolbar-bar');
          if (xiaomiToolbar && parsedXiaomiToolbar) {
            xiaomiToolbar.innerHTML = parsedXiaomiToolbar.innerHTML;
          }

          const xiaomiActive = document.getElementById('XiaomiActiveFilters');
          const parsedXiaomiActive = parsedHTML.getElementById('XiaomiActiveFilters');
          if (xiaomiActive && parsedXiaomiActive) {
            xiaomiActive.innerHTML = parsedXiaomiActive.innerHTML;
          } else if (xiaomiActive && !parsedXiaomiActive) {
            xiaomiActive.remove();
          } else if (!xiaomiActive && parsedXiaomiActive) {
            const main = document.querySelector('.xiaomi-collection__main');
            const grid = document.getElementById('ProductGridContainer');
            if (main && grid) {
              main.insertBefore(parsedXiaomiActive, grid);
            }
          }

          const id = 'FacetFiltersActive';
          if (document.getElementById(id) === null) return;
          const parsedActive = parsedHTML.getElementById(id);
          if (parsedActive) {
            document.getElementById(id).innerHTML = parsedActive.innerHTML;
          }
        }

        renderProductGridContainer(responseText) {
          const id = 'ProductGridContainer';
          if (document.getElementById(id) === null) return;
          const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
          const motionList = parsedHTML.querySelector('motion-list');
          if (motionList) motionList.setAttribute('motion-reduced', '');

          const parsedGrid = parsedHTML.getElementById(id);
          if (parsedGrid) {
            document.getElementById(id).innerHTML = parsedGrid.innerHTML;
          }
        }

        renderProductCount(responseText) {
          const id = 'ProductCount';
          if (document.getElementById(id) === null) return;
          const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');

          document.getElementById(id).innerHTML = parsedHTML.getElementById(id).innerHTML;
        }

        renderSortBy(responseText) {
          const id = 'SortByContainer';
          if (document.getElementById(id) === null) return;
          const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');

          document.getElementById(id).innerHTML = parsedHTML.getElementById(id).innerHTML;
        }
      }, { extends: 'form' }
    );
  }

  if (!customElements.get('facet-count')) {
    customElements.define(
      'facet-count',
      class FacetCount extends HTMLElement {
        constructor() {
          super();
        }

        facetUpdateUnsubscriber = undefined;

        connectedCallback() {
          this.facetUpdateUnsubscriber = theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.facetUpdate, this.onFacetUpdate.bind(this));
        }

        disconnectedCallback() {
          if (this.facetUpdateUnsubscriber) {
            this.facetUpdateUnsubscriber();
          }
        }

        get itemCount() {
          return parseInt(this.innerText);
        }

        onFacetUpdate(event) {
          const parsedHTML = new DOMParser().parseFromString(event.responseText, 'text/html');
          const facetCount = parsedHTML.querySelector('facet-count');
          this.innerText = facetCount.innerHTML;
          this.hidden = this.itemCount === 0;
        }
      }
    );
  }

  if (!customElements.get('results-count')) {
    customElements.define(
      'results-count',
      class ResultsCount extends HTMLElement {
        constructor() {
          super();
        }

        facetUpdateUnsubscriber = undefined;

        connectedCallback() {
          this.facetUpdateUnsubscriber = theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.facetUpdate, this.onFacetUpdate.bind(this));
        }

        disconnectedCallback() {
          if (this.facetUpdateUnsubscriber) {
            this.facetUpdateUnsubscriber();
          }
        }

        onFacetUpdate(event) {
          const parsedHTML = new DOMParser().parseFromString(event.responseText, 'text/html');
          const resultsCount = parsedHTML.querySelector('results-count');
          this.innerText = resultsCount.innerHTML;
        }
      }
    );
  }

  if (!customElements.get('facet-remove')) {
    customElements.define(
      'facet-remove',
      class FacetRemove extends MagnetLink {
        constructor() {
          super();

          this.addEventListener('click', this.onClick);
        }

        onClick(event) {
          const form = this.closest('form[is="facet-form"]') || document.querySelector('form[is="facet-form"]');

          if (form) {
            event.preventDefault();

            const url = new URL(this.href);
            url.searchParams.set('section_id', theme.utils.sectionId(form));
            form.renderSection(url.toString(), event);
          }
        }
      }, { extends: 'a' }
    );
  }

  if (!customElements.get('facet-sort')) {
    customElements.define(
      'facet-sort',
      class FacetSort extends HTMLElement {
        constructor() {
          super();

          Motion.inView(this, this.init.bind(this), { margin: '200px 0px 200px 0px' });

          this.addEventListener('change', this.onChange);
          this.button.addEventListener('click', this.show.bind(this));
          this.close.addEventListener('click', this.hide.bind(this));
          document.addEventListener('click', this.onWindowClick.bind(this));
        }

        get listbox() {
          return this.querySelector('.sort-listbox');
        }

        get selection() {
          return this.querySelector('.sort-selection');
        }

        get button() {
          return this.querySelector('.sort-by');
        }

        get close() {
          return this.querySelector('.sort-close');
        }

        init() {
          this.initButton();
          this.style.setProperty('--facet-listbox-height', `${this.listbox.getBoundingClientRect().height.toFixed(1)}px`);
        }

        initButton() {
          const value = this.selection.innerText;
          const width = theme.getElementWidth(this.selection, value);
          this.style.setProperty('--facet-button-width', `${width}px`);
        }

        onChange(event) {
          const form = this.closest('form[is="facet-form"]') || document.querySelector('form[is="facet-form"]');

          if (form) {
            const url = new URL(window.location.href);
            url.searchParams.set('sort_by', event.target.value);
            url.searchParams.set('section_id', theme.utils.sectionId(form));
            url.searchParams.delete('page');
            form.renderSection(url.toString(), event);
          }

          this.selection.innerText = event.target.nextElementSibling.innerText;
          this.initButton();
          this.hide();
        }

        show() {
          this.button.setAttribute('open', '');
        }

        hide(immediate = true) {
          if (this.button.hasAttribute('open')) {
            setTimeout(() => {
              this.button.removeAttribute('open');
            }, 100);

            if (theme.config.isTouch || document.body.getAttribute('data-button-hover') === 'none') return;
            
            const btnFill = this.button.querySelector('[data-fill');
            Motion.animate(btnFill, { y: ['0%', immediate ? '0%' : '-76%'] }, { duration: 0.6, delay: immediate ? 0 : 0.2 });
          }
        }

        onWindowClick(event) {
          if (!this.contains(event.target)) {
            if (this.button.hasAttribute('open')) {
              this.hide(false);
            }
          }
        }
      }
    );
  }

  if (!customElements.get('facet-sticky')) {
    customElements.define(
      'facet-sticky',
      class FacetSticky extends HTMLElement {
        constructor() {
          super();

          new IntersectionObserver(this.handleIntersection.bind(this), { rootMargin: `-${screen.availHeight - 200}px 0px ${screen.availHeight}px 0px` }).observe(document.querySelector('.collection-section'));
        }

        get button() {
          return this.querySelector('.button');
        }

        handleIntersection(entries) {
          if (entries[0].isIntersecting) {
            Motion.animate(this.button, { opacity: 1, visibility: 'visible', transform: ['translateY(15px)', 'translateY(0)'] }, { duration: 1, easing: [0.16, 1, 0.3, 1] });
          }
          else {
            Motion.animate(this.button, { opacity: 0, visibility: 'hidden', transform: ['translateY(0)', 'translateY(15px)'] }, { duration: 1, easing: [0.16, 1, 0.3, 1] });
          }
        }
      }
    );
  }

  if (!customElements.get('price-range')) {
    customElements.define(
      'price-range',
      class PriceRange extends HTMLElement {
        constructor() {
          super();

          this.rangeMin = this.querySelector('input[type="range"]:first-child');
          this.rangeMax = this.querySelector('input[type="range"]:last-child');
          this.inputMin = this.querySelector('input[name="filter.v.price.gte"]');
          this.inputMax = this.querySelector('input[name="filter.v.price.lte"]');

          this.inputMin.addEventListener('focus', this.inputMin.select);
          this.inputMax.addEventListener('focus', this.inputMax.select);
          this.inputMin.addEventListener('change', this.onInputMinChange.bind(this));
          this.inputMax.addEventListener('change', this.onInputMaxChange.bind(this));

          this.rangeMin.addEventListener('change', this.onRangeMinChange.bind(this));
          this.rangeMax.addEventListener('change', this.onRangeMaxChange.bind(this));
          this.rangeMin.addEventListener('input', this.onRangeMinInput.bind(this));
          this.rangeMax.addEventListener('input', this.onRangeMaxInput.bind(this));
        }

        onInputMinChange(event) {
          event.preventDefault();
          event.target.value = Math.max(Math.min(parseInt(event.target.value), parseInt(this.inputMax.value || event.target.max) - 1), event.target.min);
          this.rangeMin.value = event.target.value;
          this.rangeMin.parentElement.style.setProperty('--range-min', `${parseInt(this.rangeMin.value) / parseInt(this.rangeMin.max) * 100}%`);
        }

        onInputMaxChange(event) {
          event.preventDefault();
          event.target.value = Math.min(Math.max(parseInt(event.target.value), parseInt(this.inputMin.value || event.target.min) + 1), event.target.max);
          this.rangeMax.value = event.target.value;
          this.rangeMax.parentElement.style.setProperty('--range-max', `${parseInt(this.rangeMax.value) / parseInt(this.rangeMax.max) * 100}%`);
        }

        onRangeMinChange(event) {
          event.stopPropagation();
          this.inputMin.value = event.target.value;
          this.inputMin.dispatchEvent(new Event('change', { bubbles: true }));
        }

        onRangeMaxChange(event) {
          event.stopPropagation();
          this.inputMax.value = event.target.value;
          this.inputMax.dispatchEvent(new Event('change', { bubbles: true }));
        }

        onRangeMinInput(event) {
          event.target.value = Math.min(parseInt(event.target.value), parseInt(this.inputMax.value || event.target.max) - 1);
          event.target.parentElement.style.setProperty('--range-min', `${parseInt(event.target.value) / parseInt(event.target.max) * 100}%`);
          this.inputMin.value = event.target.value;
        }

        onRangeMaxInput(event) {
          event.target.value = Math.max(parseInt(event.target.value), parseInt(this.inputMin.value || event.target.min) + 1);
          event.target.parentElement.style.setProperty('--range-max', `${parseInt(event.target.value) / parseInt(event.target.max) * 100}%`);
          this.inputMax.value = event.target.value;
        }
      }
    );
  }

  if (!customElements.get('infinite-button')) {
    customElements.define(
      'infinite-button',
      class InfiniteButton extends HoverButton {
        constructor() {
          super();

          this.onClickHandler = this.onClick.bind(this);
        }

        connectedCallback() {
          this.addEventListener('click', this.onClickHandler);

          if (this.getAttribute('mode') == 'infinite') {
            Motion.inView(this, this.onClickHandler, { margin: '200px 0px 200px 0px' });
          }
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.onClickHandler);
        }

        onClick(event) {
          if (this.hasAttribute('aria-busy')) return;
          event.preventDefault();

          this.abortController?.abort();
          this.abortController = new AbortController();

          this.enableLoading();
          const url = this.buildUrl().toString();

          fetch(url, { signal: this.abortController.signal })
            .then((response) => response.text())
            .then((responseText) => {
              this.renderPagination(responseText);
              this.renderProductGridContainer(responseText);
            })
            .catch((error) => {
              if (error.name === 'AbortError') {
                console.log('Fetch aborted by user');
              }
              else {
                console.error(error);
              }
            });
        }

        renderPagination(responseText) {
          const productGridContainer = document.getElementById('ProductGridContainer');
          if (productGridContainer === null) return;

          const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
          const destination = productGridContainer.querySelector('.pagination');
          const source = parsedHTML.querySelector('.pagination');

          if (source) {
            destination.innerHTML = source.innerHTML;
          }
          else {
            destination.remove();
          }
        }

        renderProductGridContainer(responseText) {
          const productGridContainer = document.getElementById('ProductGridContainer');
          if (productGridContainer === null) return;

          const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
          const destination = productGridContainer.querySelector('motion-list');
          const source = parsedHTML.querySelector('motion-list');

          if (source && destination) {
            source.querySelectorAll('.card').forEach((item) => {
              destination.appendChild(item);
            });

            destination.reload();
            if (typeof window.facetMenuCollectionReapply === 'function') {
              window.facetMenuCollectionReapply();
            }
          }
        }
        
        buildUrl() {
          const url = new URL(this.getAttribute('action'));
          url.searchParams.set('section_id', theme.utils.sectionId(this));
          return url;
        }

        enableLoading() {
          this.classList.add('pointer-events-none');
          this.setAttribute('aria-busy', 'true');
        }
      }, { extends: 'button' }
    );
  }

  if (!customElements.get('facets-topbar')) {
    customElements.define(
      'facets-topbar',
      class FacetsTopbar extends StickyElement {
        constructor() {
          super();
        }

        positionStickySidebar() {
          const bounding = this.getBoundingClientRect();
          if (bounding.top === 0) {
            document.body.classList.add('facets-topbar--active');
          }
          else {
            document.body.classList.remove('facets-topbar--active');
          }
        }
      }
    );
  }

  if (!customElements.get('model-view')) {
    customElements.define(
      'model-view',
      class ModelView extends MagnetButton {
        constructor() {
          super();

          Motion.inView(this, this.init.bind(this), { margin: '200px 0px 200px 0px' });

          this._open = this.hasAttribute('open');
          this.onClickHandler = this.onClick.bind(this);
        }

        set open(value) {
          if (value !== this._open) {
            this._open = value;
            value ? this.setAttribute('open', '') : this.removeAttribute('open');
          }
        }

        static get observedAttributes() {
          return ['open'];
        }

        get open() {
          return this._open;
        }

        connectedCallback() {
          this.addEventListener('click', this.onClickHandler);
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.onClickHandler);
        }

        attributeChangedCallback(name, oldValue, newValue) {
          if (name === 'open') {
            this.setActiveModel(newValue === '');
          }
        }

        init() {
          if (theme.config.hasLocalStorage) {
            const isActive = window.localStorage.getItem(`${theme.settings.themeName}:model-view`) || 'false';
            this.open = isActive === 'true';
          }
        }

        onClick(event) {
          event.preventDefault();
          this.open = !this.open;
        }

        setActiveModel(isActive) {
          const container = document.getElementById('ProductGridContainer');
          container.classList.toggle('lifestyle', isActive);

          if (theme.config.hasLocalStorage) {
            window.localStorage.setItem(`${theme.settings.themeName}:model-view`, isActive);
          }
        }
      }, { extends: 'button' }
    );
  }

  /* Category facets: menu-data.js — mega-menu product URLs + top-level collection from each item.href (hybrid) */
  (function () {
    var CACHE_UNSET = {};
    var menuProductMapCache = CACHE_UNSET;
    var categoryTopCollectionCache = CACHE_UNSET;

    var CATEGORY_FILTER_KEYS = {
      'smart-phone': ['ram', 'memory', 'front-camera', 'rear-camera', 'battery', 'feature', 'display-size'],
      'feature-phones': ['battery', 'front-camera', 'rear-camera', 'feature', 'display-size'],
      'tablets': ['ram', 'memory', 'display-size'],
      'smart-watches': ['display', 'bluetooth-calling', 'water-resistance', 'battery-life'],
      'audio': ['product-type', 'battery-life', 'battery', 'water-resistance', 'anc-enc', 'display-size'],
      'personal-care': ['product-type'],
      'home-appliances': ['product-type'],
      'accessories': ['product-type'],
    };

    function storageKey() {
      return 'facetMenuCatFilter:' + (window.location.pathname || '/');
    }

    function normHandle(s) {
      return (s || '').trim().toLowerCase();
    }

    function collectionHandleFromPath() {
      var m = (window.location.pathname || '').match(/\/collections\/([^/?#]+)/i);
      if (!m) return '';
      return normHandle(decodeURIComponent(m[1]));
    }

    function isShopAllCollection() {
      var h = collectionHandleFromPath();
      return !h || h === 'all';
    }

    function getActiveCategoryHandle() {
      var pathHandle = collectionHandleFromPath();
      if (pathHandle && pathHandle !== 'all' && CATEGORY_FILTER_KEYS[pathHandle]) {
        return pathHandle;
      }
      return '';
    }

    function buildCategoryCollectionUrl(handle) {
      var url = new URL('/collections/' + encodeURIComponent(handle), window.location.origin);
      var current = new URL(window.location.href);
      ['sort_by', 'filter.v.availability', 'filter.v.price.gte', 'filter.v.price.lte'].forEach(function (key) {
        var val = current.searchParams.get(key);
        if (val !== null && val !== '') {
          url.searchParams.set(key, val);
        }
      });
      return url.toString();
    }

    function bindCategoryLinks() {
      document.querySelectorAll('.facet-menu-category-link').forEach(function (link) {
        if (link.dataset.facetCategoryBound === '1') return;
        link.dataset.facetCategoryBound = '1';
        link.addEventListener('click', function (e) {
          var handle = normHandle(link.getAttribute('data-collection-handle'));
          if (!handle) return;
          e.preventDefault();
          window.location.href = buildCategoryCollectionUrl(handle);
        });
      });
    }

    function applyCategorySubfilterVisibility() {
      var active = getActiveCategoryHandle();
      var allowed = active ? CATEGORY_FILTER_KEYS[active] || [] : [];
      var allowedSet = {};
      allowed.forEach(function (k) {
        allowedSet[k] = true;
      });

      document.querySelectorAll('.facet-category-subfilter[data-category-filter-key]').forEach(function (el) {
        var key = (el.getAttribute('data-category-filter-key') || '').trim();
        var show = !!(active && key && allowedSet[key]);
        el.classList.toggle('facet-category-subfilter--hidden', !show);
      });
    }

    function enforceSingleCategorySelection(changed) {
      if (!changed || !changed.matches || !changed.matches('input.facet-menu-collection-filter-cb')) return;
      if (!changed.checked) return;
      document.querySelectorAll('input.facet-menu-collection-filter-cb').forEach(function (el) {
        if (el !== changed) el.checked = false;
      });
    }

    function parseProductHandleFromHref(href) {
      if (!href || typeof href !== 'string') return null;
      try {
        var u = new URL(href, window.location.origin);
        var m = u.pathname.match(/\/products\/([^/?#]+)/i);
        if (!m) return null;
        return decodeURIComponent(m[1]).toLowerCase();
      } catch (e) {
        return null;
      }
    }

    function collectionHandleFromNavHref(href) {
      if (!href || typeof href !== 'string') return null;
      try {
        var u = new URL(href, window.location.origin);
        var m = u.pathname.match(/\/collections\/([^/?#]+)/i);
        if (!m) return null;
        return decodeURIComponent(m[1]).toLowerCase();
      } catch (e) {
        return null;
      }
    }

    function buildMenuCaches() {
      menuProductMapCache = {};
      categoryTopCollectionCache = {};
      var data = window.CUSTOM_NAVIGATION_DATA;
      if (!data || !data.mobileMenu || !Array.isArray(data.mobileMenu.items)) {
        return;
      }
      data.mobileMenu.items.forEach(function (item) {
        var uid = String(item.uid || '').trim();
        if (!uid) return;
        var topCol = collectionHandleFromNavHref(item.href || '');
        if (topCol) categoryTopCollectionCache[uid] = topCol;
        (item.groups || []).forEach(function (g) {
          (g.products || []).forEach(function (p) {
            var h = parseProductHandleFromHref(p.href);
            if (!h) return;
            if (!menuProductMapCache[uid]) menuProductMapCache[uid] = {};
            menuProductMapCache[uid][h] = true;
          });
        });
      });
    }

    function getMenuCategoryProductMap() {
      if (menuProductMapCache === CACHE_UNSET) buildMenuCaches();
      return menuProductMapCache;
    }

    function getCategoryTopCollectionByUid() {
      if (categoryTopCollectionCache === CACHE_UNSET) buildMenuCaches();
      return categoryTopCollectionCache;
    }

    function invalidateMenuCaches() {
      menuProductMapCache = CACHE_UNSET;
      categoryTopCollectionCache = CACHE_UNSET;
    }

    function getFilterMode() {
      if (!document.querySelector('input.facet-menu-collection-filter-cb[data-category-uid]')) {
        return 'collections';
      }
      var data = window.CUSTOM_NAVIGATION_DATA;
      if (data && data.mobileMenu && Array.isArray(data.mobileMenu.items) && data.mobileMenu.items.length) {
        return 'menu';
      }
      return 'collections';
    }

    function getSelectedCategoryUids() {
      var boxes = document.querySelectorAll('input.facet-menu-collection-filter-cb:checked');
      var seen = {};
      var uids = [];
      for (var i = 0; i < boxes.length; i++) {
        var uid = (boxes[i].getAttribute('data-category-uid') || '').trim();
        if (!uid || seen[uid]) continue;
        seen[uid] = true;
        uids.push(uid);
      }
      return uids;
    }

    function getSelectedHandles() {
      var boxes = document.querySelectorAll('input.facet-menu-collection-filter-cb:checked');
      var seen = {};
      var h = [];
      for (var i = 0; i < boxes.length; i++) {
        var v = normHandle(boxes[i].getAttribute('data-collection-handle'));
        if (!v || seen[v]) continue;
        seen[v] = true;
        h.push(v);
      }
      return h;
    }

    function syncCategoryCheckboxesFromSource(source) {
      if (!source || !source.matches || !source.matches('input.facet-menu-collection-filter-cb')) return;
      var uid = (source.getAttribute('data-category-uid') || '').trim();
      var raw = source.getAttribute('data-collection-handle');
      var checked = source.checked;
      document.querySelectorAll('input.facet-menu-collection-filter-cb').forEach(function (el) {
        if (uid && el.getAttribute('data-category-uid') === uid) {
          el.checked = checked;
        } else if (!uid && raw != null && el.getAttribute('data-collection-handle') === raw) {
          el.checked = checked;
        }
      });
    }

    function resetVisibleGridCards(container) {
      container.querySelectorAll('.product-card').forEach(function (card) {
        card.hidden = false;
        card.classList.remove('facet-menu-collection-hidden');
      });
    }

    function applyMenuProductGridFilter(container, selectedUids) {
      var map = getMenuCategoryProductMap();
      var colByUid = getCategoryTopCollectionByUid();
      var unionProducts = {};
      var unionCollections = {};
      selectedUids.forEach(function (uid) {
        var bucket = map[uid];
        if (bucket) {
          Object.keys(bucket).forEach(function (h) {
            unionProducts[h] = true;
          });
        }
        var col = colByUid[uid];
        if (col) unionCollections[col] = true;
      });
      container.querySelectorAll('.product-card[data-product-handle]').forEach(function (card) {
        var ph = normHandle(card.getAttribute('data-product-handle'));
        var byMenuList = !!(ph && unionProducts[ph]);
        var byCollection = false;
        if (!byMenuList && Object.keys(unionCollections).length) {
          var raw = card.getAttribute('data-collection-handles') || '';
          var parts = raw.split(',');
          for (var i = 0; i < parts.length; i++) {
            var c = normHandle(parts[i]);
            if (c && unionCollections[c]) {
              byCollection = true;
              break;
            }
          }
        }
        var show = byMenuList || byCollection;
        if (show) {
          card.hidden = false;
          card.classList.remove('facet-menu-collection-hidden');
        } else {
          card.hidden = true;
          card.classList.add('facet-menu-collection-hidden');
        }
      });
    }

    function applyCollectionsProductGridFilter(container, selected) {
      var cards = container.querySelectorAll('.product-card[data-collection-handles]');
      if (!selected.length) {
        resetVisibleGridCards(container);
        return;
      }
      var set = {};
      selected.forEach(function (s) {
        set[normHandle(s)] = true;
      });
      cards.forEach(function (card) {
        var raw = card.getAttribute('data-collection-handles') || '';
        var parts = raw.split(',');
        var show = false;
        for (var j = 0; j < parts.length; j++) {
          var p = normHandle(parts[j]);
          if (p && set[p]) {
            show = true;
            break;
          }
        }
        if (show) {
          card.hidden = false;
          card.classList.remove('facet-menu-collection-hidden');
        } else {
          card.hidden = true;
          card.classList.add('facet-menu-collection-hidden');
        }
      });
    }

    function applyProductGridFilter() {
      applyCategorySubfilterVisibility();
    }

    function persistSelection() {
      var mode = getFilterMode();
      var payload = {
        m: mode === 'menu' ? 1 : 0,
        v: mode === 'menu' ? getSelectedCategoryUids() : getSelectedHandles(),
      };
      try {
        sessionStorage.setItem(storageKey(), JSON.stringify(payload));
      } catch (e) {}
    }

    function restoreCheckboxes() {
      var pathHandle = collectionHandleFromPath();
      if (pathHandle && pathHandle !== 'all' && CATEGORY_FILTER_KEYS[pathHandle]) {
        document.querySelectorAll('input.facet-menu-collection-filter-cb').forEach(function (el) {
          var h = normHandle(el.getAttribute('data-collection-handle'));
          el.checked = h === pathHandle;
        });
        return;
      }

      var urlCat = '';
      try {
        urlCat = new URL(window.location.href).searchParams.get('cat') || '';
      } catch (e) {}

      if (urlCat && getFilterMode() === 'menu') {
        var wantedUidFromUrl = {};
        wantedUidFromUrl[String(urlCat).trim()] = true;
        document.querySelectorAll('input.facet-menu-collection-filter-cb').forEach(function (el) {
          var uid = (el.getAttribute('data-category-uid') || '').trim();
          el.checked = !!(uid && wantedUidFromUrl[uid]);
        });
        applyProductGridFilter();
        return;
      }

      var raw;
      try {
        raw = sessionStorage.getItem(storageKey());
      } catch (e) {
        return;
      }
      if (!raw) return;
      var parsed;
      try {
        parsed = JSON.parse(raw);
      } catch (e) {
        return;
      }
      var modeMenu = false;
      var arr = [];
      if (parsed && typeof parsed === 'object' && Array.isArray(parsed.v)) {
        modeMenu = parsed.m === 1;
        arr = parsed.v;
      } else if (Array.isArray(parsed)) {
        modeMenu = false;
        arr = parsed;
      }
      if (!arr.length) return;

      if (modeMenu && getFilterMode() === 'menu') {
        var wantedUid = {};
        arr.forEach(function (u) {
          if (u) wantedUid[String(u).trim()] = true;
        });
        document.querySelectorAll('input.facet-menu-collection-filter-cb').forEach(function (el) {
          var uid = (el.getAttribute('data-category-uid') || '').trim();
          el.checked = !!(uid && wantedUid[uid]);
        });
        return;
      }

      var wanted = {};
      arr.forEach(function (h) {
        var k = normHandle(h);
        if (k) wanted[k] = true;
      });
      document.querySelectorAll('input.facet-menu-collection-filter-cb').forEach(function (el) {
        var h = normHandle(el.getAttribute('data-collection-handle'));
        el.checked = !!(h && wanted[h]);
      });
    }

    function onFacetMenuCollectionChange(ev) {
      if (ev && ev.target) {
        if (ev.target.matches && ev.target.matches('input.facet-audio-subcategory-filter-cb')) {
          document.querySelectorAll('input.facet-menu-collection-filter-cb').forEach(function (el) {
            el.checked = false;
          });
        } else if (ev.target.matches && ev.target.matches('input.facet-menu-collection-filter-cb')) {
          document.querySelectorAll('input.facet-audio-subcategory-filter-cb').forEach(function (el) {
            el.checked = false;
          });
          enforceSingleCategorySelection(ev.target);
          syncCategoryCheckboxesFromSource(ev.target);
        }
      }
      persistSelection();
      applyProductGridFilter();
    }

    window.facetMenuCollectionOnChange = onFacetMenuCollectionChange;
    window.facetMenuCollectionReapply = applyProductGridFilter;
    window.facetCategorySubfilterRefresh = applyCategorySubfilterVisibility;
    window.facetMenuCategoryBindLinks = bindCategoryLinks;

    var facetPubsubBound = false;
    var gridMo = null;
    var gridDebounce = null;

    function bindFacetPubsubOnce() {
      if (facetPubsubBound) return;
      if (!window.theme || !theme.pubsub || !theme.pubsub.subscribe || !theme.pubsub.PUB_SUB_EVENTS) return;
      facetPubsubBound = true;
      theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.facetUpdate, function () {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            bindCategoryLinks();
            applyCategorySubfilterVisibility();
          });
        });
      });
    }

    function bindProductGridObserver() {
      var container = document.getElementById('ProductGridContainer');
      if (!container || typeof MutationObserver === 'undefined') return;
      if (gridMo) {
        gridMo.disconnect();
        gridMo = null;
      }
      gridMo = new MutationObserver(function () {
        clearTimeout(gridDebounce);
        gridDebounce = setTimeout(function () {
          applyProductGridFilter();
        }, 60);
      });
      gridMo.observe(container, { childList: true, subtree: true });
    }

    function initFacetMenuCollectionFilter() {
      invalidateMenuCaches();
      bindFacetPubsubOnce();
      bindCategoryLinks();
      applyCategorySubfilterVisibility();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFacetMenuCollectionFilter);
    } else {
      initFacetMenuCollectionFilter();
    }

    document.addEventListener('shopify:section:load', initFacetMenuCollectionFilter);

    document.addEventListener('collection:reloaded', function () {
      requestAnimationFrame(function () {
        bindCategoryLinks();
        applyCategorySubfilterVisibility();
      });
    });

    document.addEventListener(
      'change',
      function (e) {
        var t = e.target;
        if (t && t.matches && t.matches('input.facet-menu-collection-filter-cb')) {
          if (typeof window.facetMenuCollectionOnChange === 'function') {
            window.facetMenuCollectionOnChange(e);
          }
        }
        if (t && t.matches && t.matches('input.facet-audio-subcategory-filter-cb')) {
          if (typeof window.facetMenuCollectionOnChange === 'function') {
            window.facetMenuCollectionOnChange(e);
          }
        }
      },
      false
    );
  })();
